import React from 'react';
import type {
  HeaderAnimationState,
  IHeaderSectionProps,
} from '../HeaderSection.types';
import headerStyles from './HeaderSectionBuilder.scss';
import classNames from 'clsx';
import styles from '../../Section/viewer/styles/Section.scss';
import semanticClassNames from '../HeaderSection.semanticClassNames';
import Section from '../../Section/viewer/Section';

interface HeaderSectionBuilderOwnProps {
  animationState: HeaderAnimationState;
  scrolled: boolean;
}
type Props = IHeaderSectionProps & HeaderSectionBuilderOwnProps;

const HeaderSectionBuilder: React.FC<Props> = props => {
  const isFadedDown =
    props.animationState === 'scrolled-down' && props.animate === 'fade';

  return (
    <div
      id={'header-section-wrapper_' + props.id}
      className={classNames(headerStyles.root, props.className, {
        [styles.animate]: props.animate !== 'none',
        [styles.move]:
          props.animationState === 'scrolled-down' && props.animate === 'move',
        [styles.fade]: isFadedDown,
        [styles.headerSectionAddVisibilityTransition]:
          isFadedDown && props.isHeaderSectionAddVisibilityTransitionEnabled,
        [styles.scrollUp]: props.animationState === 'scrolled-up',
        [styles.scrolled]: props.scrolled,
      })}
    >
      <Section
        {...props}
        semanticClassNames={semanticClassNames}
        className={classNames(props.className, {
          [styles[props.skin]]: true,
        })}
      />
    </div>
  );
};

export default HeaderSectionBuilder;
